import React from 'react';
import { IObjectWithIdAndIdentifier } from 'gen/ApiClient';

export interface IContext {
	data: IObjectWithIdAndIdentifier<string>[] | undefined;
	init: () => Promise<void>;
}

export const LocalizedHealthInsuranceFundsCacheContext = React.createContext<IContext>(undefined as any);
